module.exports = __webpack_public_path__ + "static/media/avatar15.0cb12b60.png";